import { render, staticRenderFns } from "./LogisticaContainer.vue?vue&type=template&id=66e74e57&scoped=true"
import script from "./LogisticaContainer.vue?vue&type=script&lang=js"
export * from "./LogisticaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e74e57",
  null
  
)

export default component.exports